import { render, staticRenderFns } from "./ProductDescDetail.vue?vue&type=template&id=1f074806&"
import script from "./ProductDescDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDescDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports